import React, { Component } from 'react';
import * as actions from '../../../../../redux/actions/index';
import { connect } from 'react-redux';
import { animateScroll as scroll } from 'react-scroll'
import AddAvailability from '../../../../component/TimeTrackerModuleComponent/AvailabilityComponent/AddAvailability/addAvailability';
import { convertDateFormatV4, convertTo24HourFormat, getInbetweenWeekDates, getInbetweenWeekDates_V1, getUser, makeFirstLetterCapital } from '../../../../../utility/utility';
import errorHandler from '../../../../../utility/errorHandler/errorHandler';
import { tzUTCDateConverterTool_V2, tzUTCDateTimeConverterTool_V1, tzUTCTCustomDateAndTimeConverterTool, tzUTCTimeConverterTool_V1 } from '../../../../../utility/TimezoneOperations/timezoneUtility';
import moment from 'moment';

const cloneDeep = require('clone-deep');

class AddAvailabilityContainer extends Component {

  constructor(props) {
    super(props);

    this.state = {
    }
  }

  onCancelClicked = () => {
    this.props.history.goBack();
  }

  addNewUser = (values) => {
    
    let value = cloneDeep(values);
    let end_date = ''
    let start_date = ''
    let availability = []
    let user_id = this.props.match.params?.userId
    let selectedAvailabilityDayRange = getInbetweenWeekDates_V1(values.data.start_date, values.data.end_date);
    const dayMap = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
    const platform = "web";


    start_date = tzUTCDateTimeConverterTool_V1(value.data?.start_date, '00:00:00', 'from');
    end_date = tzUTCDateTimeConverterTool_V1(value.data?.end_date, '00:00:00', 'to');

     const getDays = value.data.availability.map((item, index) => {
      if(item.day){
        return {
          ...item,
          day : dayMap[index]
        }
      }else{
        return{...item}
      }
     })

      const checkAvailability = getDays.filter((item) => {
           if(item.day){
            return item.day
           }
      })
      
      if(!checkAvailability.length){
        errorHandler('Please select atleast One Day')
        return false
      }

      
      availability = checkAvailability.map((item, index) => {
           return {
            day : item.day,
            slots : item.slot.map((subItem) => {debugger
              let endTime;
              if(convertTo24HourFormat(subItem.end) < convertTo24HourFormat(subItem.start)){
                endTime = moment(value.data.end_date).add(1, 'day')._d
              }else{
                endTime = value.data.end_date
              }
              return {
                start: tzUTCTCustomDateAndTimeConverterTool(convertDateFormatV4(value.data.start_date), convertTo24HourFormat(subItem.start)),
                end : tzUTCTCustomDateAndTimeConverterTool(convertDateFormatV4(endTime), convertTo24HourFormat(subItem.end)),
              } 
            })
           }
      })
      
    const data = {
      start_date,
      end_date,
      availability,
      user_id,
      platform
    }

    if (data && data.availability && data.availability.length > 0) {

      let unmatchedDays = data.availability.reduce((unmatched, data) => {
        let day = makeFirstLetterCapital(data.day);
        if (!selectedAvailabilityDayRange.includes(day)) {
          unmatched.push(day);
        }
        return unmatched;
      }, []);

      if (unmatchedDays.length > 0) {
        errorHandler(`Selected [ ${unmatchedDays.join(', ')} ] days are outside the scope of the selected date range.`);
        return false;
      }

    }
    debugger
    this.props.addAvailability({ data })

  }

  componentDidMount() {
    scroll.scrollToTop();
  }

  componentWillUnmount() {
    this.props.resetObjects();
  }


  render() {

    return (
      <>
        <AddAvailability
          {...this.props}
          onSubmit={this.addNewUser}
          onCancelClicked={this.onCancelClicked}
          isLoading={this.props.isLoading}
        />
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    isLoading: state.TimeTrackerModReducer.isLoading,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    resetObjects: () => dispatch(actions.resetObjects()),
    addAvailability: (body) => dispatch(actions.addAvailability(body)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddAvailabilityContainer);